import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './login/LoginPage';
import ResetPage from './reset/ResetPasswordPage';

export default function LoginRouter() {
  return (
    <Routes>
      <Route element={<LoginPage />} index />
      <Route element={<ResetPage />} path="reset" />
      <Route element={<Navigate to="" />} path="*" />
    </Routes>
  );
}
